import { OrganizationAddress } from '../types'

export function getAddress(address: OrganizationAddress): string {
  const { region, settlement, district, street, house, flat } = address
  const districtStr = district ? `${district} р-н,` : ''
  const flatStr = flat ? `, кв. ${flat}` : ''

  return `${region} ${settlement} ${districtStr} вул. ${street} буд. ${house}${flatStr}`
}
